// extracted by mini-css-extract-plugin
export default {"notes":"notes__jU12Z"};